import { render, staticRenderFns } from "./GreenCardRequestForm.vue?vue&type=template&id=606b7c24"
import script from "./GreenCardRequestForm.vue?vue&type=script&lang=js"
export * from "./GreenCardRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports